import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import KeyValueDTO from '../models/generic/KeyValueDTO';

export class CultureApiController {
    // get: Culture/GetAllCultures
    public RouteGetAllCultures = () => `Culture/GetAllCultures`;
    public getAllCultures(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<string, number>[]>> {
        let url = this.RouteGetAllCultures();
        return HttpApi.RestRequest<any, KeyValueDTO<string, number>[]>(null, 'get', url, requestOptions);
    }
}
var service = new CultureApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/CultureApiController.ts